define([
	'internal_util/Util',
	'internal_util/Base64Util',
	'model/bindings/AbstractKeyBindingType'
], function (
	Util,
	Base64Util,
	AbstractKeyBindingType
) {
	'use strict';

	/**
	 * FidoWebAuthnBindingType class
	 * 
	 * @returns {FidoWebAuthnBindingType}
	 */
	return function (attestationObject, clientData, appId, credentialId, nonce, pvr, salt) {
		
		AbstractKeyBindingType.call(this, "FIDO/WebAuthn", "http://ws.skidentity.de/ci/binding/key/v1.0", salt);

		var _attestationObject = attestationObject,
				_clientData = clientData,
				_credentialId = credentialId,
				_nonce = nonce,
				_pvr = pvr,
				_appId = appId;

		// public methods

		this.attestation = function() {
			return _attestationObject;
		};

		this.appId = function() {
			return _appId;
		}
		
		this.nonce = function() {
			return _nonce;
		}
		
		this.pvr = function() {
			return _pvr;
		}

		this.secret = function() {
			return null;
		};

		this.clientData = function() {
			return _clientData;
		}

		this.credentialId = function() {
			return _credentialId;
		}

		this.toObject = function () {
			return {
				type : this.type(),
				origin : this.origin(),
				salt: this.salt(),
				credentialId: Base64Util.encodeBase64Url(this.credentialId())
			};
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/bindings/FidoWebAuthnBindingType.js
// module id = 272
// module chunks = 3